import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { isString, isEmpty, __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import { mapProps } from '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import { commonPropKeys } from '../types.esm.js';
export { commonPropKeys as propKeys } from '../types.esm.js';
import Icon from '../Icon/index.esm.js';
import Spinner from '../Spinner/index.esm.js';
import useButtonStyles from './styles.esm.js';

var ButtonIcon = function ButtonIcon(props) {
  return React__default.createElement(Icon, _extends({
    flexShrink: "flex-shrink-0",
    transform: "transform",
    transitionProperty: "transition-all",
    transitionDuration: "duration-200",
    transitionTimingFunction: "ease-in-out"
  }, props));
};

var Button = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var as = props.as,
      _props$position = props.position,
      position = _props$position === void 0 ? 'relative' : _props$position,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'default' : _props$appearance,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 'default' : _props$spacing,
      href = props.href,
      target = props.target,
      external = props.external,
      iconBefore = props.iconBefore,
      iconBeforeSize = props.iconBeforeSize,
      iconBeforeRotate = props.iconBeforeRotate,
      iconAfter = props.iconAfter,
      iconAfterSize = props.iconAfterSize,
      iconAfterRotate = props.iconAfterRotate,
      iconSize = props.iconSize,
      iconRotate = props.iconRotate,
      disabled = props.disabled,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      loadingText = props.loadingText,
      onClick = props.onClick,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["as", "position", "type", "appearance", "size", "spacing", "href", "target", "external", "iconBefore", "iconBeforeSize", "iconBeforeRotate", "iconAfter", "iconAfterSize", "iconAfterRotate", "iconSize", "iconRotate", "disabled", "loading", "loadingText", "onClick", "active", "fullWidth", "children"]);

  var styleProps = useButtonStyles({
    active: active,
    appearance: appearance,
    disabled: disabled,
    fullWidth: fullWidth,
    loading: loading,
    position: position,
    size: size,
    spacing: spacing
  }); // Whether to use a button element

  var useButton = !isString(href) || isEmpty(href);
  var externalProps = !useButton && external ? {
    target: target || '_blank',
    rel: 'noopener noreferrer'
  } : null;

  if (loading && !loadingText) {
    styleProps.textOpacity = 'text-opacity-0';
  }

  var renderIcons = !loading || !loadingText;
  var content = React__default.createElement(React__default.Fragment, null, loading && React__default.createElement(Spinner, {
    position: !loadingText ? 'absolute' : undefined,
    inset: !loadingText ? 'inset-auto' : undefined,
    margin: loadingText ? 'mr-2' : undefined,
    size: size === 'sm' ? 'sm' : 'md',
    textColor: styleProps.textColor
  }), iconBefore && renderIcons && React__default.createElement(ButtonIcon, {
    name: iconBefore,
    size: iconBeforeSize || iconSize,
    rotate: iconBeforeRotate || iconRotate,
    margin: "mr-2"
  }), loading && loadingText || children, iconAfter && renderIcons && React__default.createElement(ButtonIcon, {
    name: iconAfter,
    size: iconAfterSize || iconSize,
    rotate: iconAfterRotate || iconRotate,
    margin: "ml-2"
  }));
  return React__default.createElement(as || useButton ? 'button' : 'a', _extends({
    ref: ref,
    type: useButton ? type : undefined,
    href: href,
    target: !useButton ? target : undefined,
    onClick: disabled && !useButton ? function (e) {
      return e.preventDefault();
    } : onClick,
    disabled: disabled,
    'aria-disabled': disabled
  }, mapProps(_extends({}, styleProps, props), rest, commonPropKeys), externalProps), content);
});

if (__DEV__) {
  Button.displayName = 'Button';
}

export default Button;
//# sourceMappingURL=index.esm.js.map
